import { fetchLuxPlusSubscriptionRenewalPaymentCards } from 'actions/LuxPlusActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useLuxPlusSubscriptionRenewalPaymentCards(shouldFetch = true, refetch = false) {
  const dispatch = useAppDispatch()
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)
  const subscriptionId = useAppSelector(state => state.auth.account.luxPlus.member.subscription.item?.id)
  const renewalPaymentCards = useAppSelector(state => state.auth.account.luxPlus.member.subscription.renewalPaymentCards)

  useEffect(() => {
    if (!shouldFetch) return

    dispatch(fetchLuxPlusSubscriptionRenewalPaymentCards({ refetch }))
  }, [dispatch, refetch, regionCode, shouldFetch, subscriptionId])

  return renewalPaymentCards
}

export default useLuxPlusSubscriptionRenewalPaymentCards
